module.exports = __webpack_public_path__ + "img/i_send_checked.0648ddb5.svg";